import React from 'react';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import { ErrorMessage } from '../../../../../../../Services/styled-components';
import { StyledQuestionFieldContainer } from '../../styles';
import TogglesEditor from './TogglesEditor';
import { validateStructuredInput } from './validation';

interface Props {
  control: Control<EditableQuestion>;
  setValue: UseFormSetValue<EditableQuestion>;
}

/**
 * Rendered across the full width of the editor: a field row carries an id, a keyboard, a
 * suffix and three numeric limits, which will not fit in a settings column.
 */
const StructuredInputBuilder = ({ control, setValue }: Props) => (
  <StyledQuestionFieldContainer>
    <TogglesEditor control={control} setValue={setValue} />
    <Controller
      name="input"
      control={control}
      rules={{ validate: validateStructuredInput }}
      render={({ fieldState }) => <ErrorMessage>{fieldState.error?.message}</ErrorMessage>}
    />
  </StyledQuestionFieldContainer>
);

export default StructuredInputBuilder;
